<template>
  <v-card :class="cardClass">
    <v-card-title>Update Password</v-card-title>
    <v-card-text class="pb-0">
      <v-form ref="passwordUpdate">
        <v-row>
          <v-col cols="12" md="3" class="py-0">
            <v-text-field
              label="Current Password"
              prepend-icon="mdi-lock"
              type="password"
              :rules="passwordRules"
              v-model="oldPassword"
              required
            />
          </v-col>
          <v-col cols="12" md="3" class="py-0">
            <v-text-field
              label="New Password"
              prepend-icon="mdi-lock"
              type="password"
              :rules="passwordRules"
              v-model="password"
              required
            />
          </v-col>
          <v-col cols="12" md="3" class="py-0">
            <v-text-field
              label="Confirm Password"
              prepend-icon="mdi-lock"
              type="password"
              :rules="confirmPasswordRules"
              v-model="confirmPassword"
              required
            />
          </v-col>
        </v-row>
        <v-card-actions md="3" class="px-5 pb-5">
          <v-spacer />
          <v-btn @click="submit" color="primary" depressed>
            Update
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Parse from 'parse'
import { mapGetters, mapActions } from 'vuex'
import validationRules from '@/validation-rules'

export default {
  props: {
    cardClass: {
      type: String,
      default: ''
    }
  },
  computed: mapGetters(['user', 'userObj']),
  data () {
    return {
      oldPassword: '',
      password: '',
      confirmPassword: '',
      ...validationRules,
      confirmPasswordRules: [
        v => !!v || 'Type confirm password',
        v => v === this.password || 'The password confirmation does not match.'
      ]
    }
  },
  methods: {
    ...mapActions(['updateUser', 'toggleDialog']),
    async submit () {
      const self = this
      if (this.$refs.passwordUpdate.validate()) {
        /** First check if the current password works */
        await Parse.User.logIn(self.user.get('username'), self.oldPassword)
          .then(() => {
            /** We are good to go to update the password */
            self.updateUser({
              password: self.password
            })
            this.toggleDialog({
              status: true,
              title: 'Success',
              message: 'New password updated successfully'
            })
          })
          .catch(function (e) {
            self.toggleDialog({
              status: true,
              title: 'Error',
              message: e.message
            })
          })
      }
    }
  }
}
</script>
